import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  action: {
    marginRight: '0.3rem',
  },
}));

export default useStyles;
